import React, { useEffect } from "react";
import { Wrapper } from "./styled";
import Form from "./components/Form";
import { useDispatch, useSelector } from "react-redux";
import { selectProfileDefaultRoute, selectTokenExpires, selectUser, selectUserId } from "store/Login/selectors";
import { BYPASS_LOGIN, PATH_FISCAL_KEY_FIRST_LOGIN, PATH_FISCAL_KEY_LOGIN, PATH_FISCAL_KEY_LOGIN_VALIDATION } from "components/pages/App/constants";
import { push } from "connected-react-router";
import { get } from "lodash";
import { resetError } from "store/Login/actions/actions";
import { internalSignOut } from "store/Login/actions/actions";

const FirstSignUp = () => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const id = useSelector(selectUserId);
  const uid = get(user, "firebaseDataId", "");
  const profileId = get(user, "profileId", null);
  const internalUser = uid && profileId; //It is registered but has not yet been assigned a profile.
  const defaultRoute = useSelector(selectProfileDefaultRoute);
  const tokenExpires = useSelector(selectTokenExpires);
  const isTokenExpired = () => tokenExpires < Date.now() / 1000;
  const email = get(user, "email", "");
  const phone = get(user, "phone", "");
  const formCompleted = phone && email;

  const temporaryLogout = () => setTimeout(() => dispatch(internalSignOut()), 5000);

  useEffect(() => {
    if (!id && BYPASS_LOGIN) dispatch(push(PATH_FISCAL_KEY_LOGIN));
    else if (uid && !internalUser) temporaryLogout();
    else if (id && formCompleted && !profileId) dispatch(push(PATH_FISCAL_KEY_LOGIN_VALIDATION));
    else if (id && formCompleted && !isTokenExpired()) dispatch(push(defaultRoute));
    // else if (id && BYPASS_LOGIN) dispatch(push(defaultRoute));
    else if (id && BYPASS_LOGIN) dispatch(push(PATH_FISCAL_KEY_FIRST_LOGIN));
  }, [user]);

  useEffect(() => {
    return () => dispatch(resetError());
  }, []);

  return (
    <Wrapper>
      <Form />
    </Wrapper>
  );
};

export default FirstSignUp;
